export const WFP_ACCOMMODATION_THREADS = {
    passengers: "9f25db49-b36e-47e8-8eb2-282e2bf9f536",
    focal_point: "fa68670a-aa7e-487d-a6d0-a188e9862ec0",
};
export function _generateUUID() {
    let dt = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        // tslint:disable-next-line:no-bitwise
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        // tslint:disable-next-line:no-bitwise
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}
export function mainThread(thread) {
    return thread || WFP_ACCOMMODATION_THREADS.passengers;
}
export function isMamMessage(msg) {
    return msg.stanza && msg.stanza.rawStanza && msg.stanza.rawStanza.indexOf(' queryid="') !== -1;
}
export function isIncomingMessage(msg) {
    return msg.stanza && msg.stanza.direction === "in";
}
export function getValueInt(value) {
    if (value === null) {
        return 0;
    }
    const num = Number(value);
    return Number.isInteger(num) ? num : 0;
}
export function debounce(handlerFunc, delay = 1000) {
    let timerId = null;
    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => handlerFunc(...args), delay);
    };
}
export function getUrlQueryParams() {
    return Object.fromEntries(new URLSearchParams(window.location.search));
}
export function getParseTextContentFromHtml(html) {
    const htmlElement = new DOMParser().parseFromString(html, "text/html");
    return htmlElement.body.textContent;
}
